// extracted by mini-css-extract-plugin
module.exports = {"active-lives":"style_active-lives__VWLec"};